module.exports = __webpack_public_path__ + "static/media/Lapampa.129efd56.svg";